<template>
  <v-container grid-list-xs fluid>
    <v-layout
      row
      wrap
      fill-height
      class="shadow white pa-4 justify-space-between"
    >
      <v-flex xs12 md6>
        <h2 class="pt-2">
          {{ CSO.name }}
          <span
            class="hint body-2 font-weight-medium"
            :class="`${summary.decision}--text`"
            >({{ summary.decision }})</span
          >
        </h2>
        <p>
          <span class="caption">{{ summary.recommendation }}</span>
        </p>
      </v-flex>
      <v-flex xs12 md6 class="di-flex justify-end ">
        <apex-chart
          type="bar"
          height="300px"
          :series="series"
          min-width="360px"
          :options="chartOptions"
        />
      </v-flex>
      <v-flex xs12 class="di-flex justify-end">
        <p style="width:400px">
          <strong class="hint">
            Award of Best Practice
            <span v-if="summary.excellence_award == 'YES'"
              >Excellence Award</span
            >
          </strong>
          <br />
          <span class="caption">{{ summary.best_award_sections }}</span>
          <br />
        </p>
      </v-flex>
      <assessmentsTable
        :cso="CSO"
        type="profile"
        :items="items"
        @reload="initData"
        class="flex xs12"
      />
      <cso-workshops :cso="CSO" :items="CSO.workshops" class="flex xs12 mt-5" />
    </v-layout>
  </v-container>
</template>
<script>
import assessmentsTable from "./assessmentsTable";
import csoWorkshops from "./csoWorkshops";
export default {
  name: "viewCSO",
  components: { assessmentsTable, csoWorkshops },
  data() {
    return {
      chartOptions: {
        width: "500px",
        colors: ["#FFC107", "#00BCD4"],
        plotOptions: {
          bar: {
            barHeight: "80%",
            horizontal: false,
            dataLabels: {
              position: "top" // top, center, bottom
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return val + "%";
          },
          offsetY: -20,
          offsetX: 1,
          style: {
            fontSize: "10px",
            colors: ["#000"]
          }
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"]
        },
        xaxis: {
          categories: ["IG&SP", "PM", "FM", "HRM", "EXT-C"],
          labels: {
            show: true,
            rotate: 0,
            rotateAlways: false
          }
        },
        yaxis: { show: false, max: 100 },
        fill: {
          opacity: 1
        },
        tooltip: {
          show: false
        }
      },
      CSO: {},
      items: [],
      score_cards: [],
      last_assessment: { summary: {}, score_cards: [] }
    };
  },

  computed: {
    summary: vm => vm.last_assessment.summary || { items: [] },

    series() {
      let compulsory_scores = [];
      let regular_scores = [];
      this.last_assessment.score_cards.forEach(item => {
        let compulsory_percent = item.total_compulsory
          ? (Number(item.compulsory_score) * 100) /
            (Number(item.total_compulsory) * 4)
          : 0;
        let regular_percent =
          (Number(item.regular_score) * 100) / (Number(item.total_regular) * 4);
        compulsory_scores.push(parseInt(compulsory_percent));
        regular_scores.push(parseInt(regular_percent));
      });
      return [
        {
          name: "Compulsory",
          data: compulsory_scores
        },
        {
          name: "Regular",
          data: regular_scores
        }
      ];
    },

    percentages: vm =>
      vm.last_assessment.score_cards.map(item => {
        let score = Number(item.regular_score) + Number(item.compulsory_score);
        let complete_score =
          (Number(item.total_compulsory) + Number(item.total_regular)) * 4;
        let percentage = (score * 100) / complete_score;
        return percentage;
      })
  },

  methods: {
    async initData() {
      let CSO_id = this.$route.params.id;
      await this.axios.get(`/CSOs/${CSO_id}`).then(res => {
        this.CSO = res.data.data;
      });

      await this.axios
        .get(`assessments?cso_id=${CSO_id}&&scoreCards=${true}`)
        .then(res => {
          this.items = res.data.data;
          this.last_assessment = res.data.data[res.data.data.length - 1];
        });
    }
  },
  created() {
    this.initData();
  }
};
</script>
<style>
.no-border td + td {
  border-left: none !important;
}
</style>
